export default __webpack_public_path__ + "static/media/breakdance.add27df6.gif";